"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Benefit = void 0;
var _presentationComponents = require("@ori/presentation-components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _BenefitsLayoutClasses = require("./BenefitsLayoutClasses");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Benefit = (param)=>{
    let { benefit } = param;
    var _benefit_content_, _benefit_content;
    const { getTestId } = (0, _testidGenerator.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.BenefitBox, {
        className: _BenefitsLayoutClasses.benefitsLayoutClasses.benefitBox,
        "data-testid": getTestId(_constants.BENEFITS_BOX),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.BoxIcon, {
                "data-testid": getTestId(_constants.BENEFITS_BOX_ICON),
                children: (benefit === null || benefit === void 0 ? void 0 : benefit.icon) != null ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_presentationComponents.Icon, {
                    iconName: benefit.icon
                }) : null
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.BoxContent, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.BoxTitle, {
                        "data-testid": getTestId(_constants.BENEFITS_BOX_TITLE),
                        children: benefit === null || benefit === void 0 ? void 0 : benefit.caption
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.InnerTextWrapper, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Text, {
                            "data-testid": getTestId(_constants.BENEFITS_BOX_TEXT),
                            children: benefit === null || benefit === void 0 ? void 0 : (_benefit_content = benefit.content) === null || _benefit_content === void 0 ? void 0 : (_benefit_content_ = _benefit_content[0]) === null || _benefit_content_ === void 0 ? void 0 : _benefit_content_.text
                        })
                    })
                ]
            })
        ]
    });
};
exports.Benefit = Benefit;
